module.exports = {
      id: "x-usage",
      viewBox: "0 0 300 300.251",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#x",
      toString: function () {
        return this.url;
      }
    }